import { useState } from "react";
import { SectionHeader } from "./SectionHeader";

const SLIDES = [
  { label: "Panel financiero", src: "/screenshots/dashboard.jpg" },
  { label: "Inventario", src: "/screenshots/inventario.jpg" },
  { label: "Asistente de IA", src: "/screenshots/ai.jpg" },
  { label: "Estadísticas", src: "/screenshots/estadisticas.jpg" },
];

export default function Screenshots({ C }) {
  const [idx, setIdx] = useState(0);
  const go = (dir) => setIdx(i => (i + dir + SLIDES.length) % SLIDES.length);

  return (
    <section style={{ padding: "64px 20px", maxWidth: 900, margin: "0 auto" }}>
      <SectionHeader C={C} eyebrow="Capturas" title="Así se ve CuadraAI en acción" />
      <div style={{ position: "relative", marginTop: 36, maxWidth: 340, margin: "36px auto 0" }}>
        <div style={{
          position: "relative", background: `linear-gradient(135deg, ${C.primary}22, ${C.blue}15)`,
          border: `1px solid ${C.border}`, borderRadius: 28, boxShadow: C.shadow,
          overflow: "hidden", aspectRatio: "9/18.5",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <span style={{ position: "relative", color: C.muted, fontSize: 13, fontWeight: 700, zIndex: 0 }}>
            {SLIDES[idx].label}
          </span>
          <img
            key={idx}
            src={SLIDES[idx].src}
            alt={SLIDES[idx].label}
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "contain", animation: "fadeIn 0.35s ease", zIndex: 1 }}
            onError={e => { e.currentTarget.style.opacity = 0; }}
          />
        </div>

        <button aria-label="Captura anterior" onClick={() => go(-1)} style={navBtnStyle(C, "left")}>‹</button>
        <button aria-label="Siguiente captura" onClick={() => go(1)} style={navBtnStyle(C, "right")}>›</button>
      </div>

      <div style={{ display: "flex", justifyContent: "center", gap: 2, marginTop: 18 }}>
        {SLIDES.map((s, i) => (
          <button key={s.label} aria-label={`Ir a ${s.label}`} onClick={() => setIdx(i)} style={{
            width: 34, height: 34, minWidth: 34, minHeight: 34, borderRadius: "50%",
            border: "none", background: "transparent", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <span style={{
              width: i === idx ? 22 : 8, height: 8, borderRadius: 4,
              background: i === idx ? C.primary : C.border, transition: "all 0.25s", display: "block",
            }} />
          </button>
        ))}
      </div>
      <div style={{ textAlign: "center", color: C.muted, fontSize: 12.5, marginTop: 10 }}>
        {SLIDES[idx].label}
      </div>
    </section>
  );
}

function navBtnStyle(C, side) {
  return {
    position: "absolute", top: "50%", [side]: 12, transform: "translateY(-50%)",
    width: 44, height: 44, borderRadius: "50%", border: `1px solid ${C.border}`,
    background: `${C.bgSidebar}E6`, color: C.text, fontSize: 20, cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(6px)",
  };
}